import React, { useEffect, useState } from "react";
import axiosInstance from '../api/axiosInstance';
import { Container } from "react-bootstrap";
import { FaChartLine, FaArrowTrendUp, FaArrowTrendDown } from "react-icons/fa6";
import { ClipLoader } from "react-spinners";

const StockMarket = () => {
    const [stocks, setStocks] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchStocks = async () => {
            setLoading(true);
            try {
                const response = await axiosInstance.get("https://blogapi.wajok.com/api/stock/getStockMarket");
                setStocks(response.data.response.homeMajors || []);
            } catch (error) {
                console.error("데이터 가져오기 실패:", error);
            }
            setLoading(false);
        };

        fetchStocks();
    }, []);

    return (
        <div className="market-wrapper">
            <Container>
                <h4 className="fw-bold d-flex align-items-center gap-2 mb-4">
                    <FaChartLine className="text-primary" /> 주요 주식 시장 시황
                </h4>

                {loading ? (
                    <div className="text-center my-5">
                        <ClipLoader color="#3182ce" size={40} />
                        <p className="text-muted small mt-2">시황 정보를 불러오는 중...</p>
                    </div>
                ) : stocks.length > 0 ? (
                    <div className="finance-ticker-grid">
                        {stocks.map((stock, index) => {
                            const isNegative = parseFloat(stock.fluctuationsRatio) < 0;
                            const isPositive = parseFloat(stock.fluctuationsRatio) > 0;
                            const trendClass = isNegative ? "negative" : isPositive ? "positive" : "";
                            const TrendIcon = isNegative ? FaArrowTrendDown : FaArrowTrendUp;

                            return (
                                <div key={index} className={`finance-ticker-card ${trendClass}`}>
                                    <div className="ticker-header">
                                        <div>
                                            <div className="ticker-name">{stock.name}</div>
                                            {stock.itemCode && (
                                                <span className="ticker-code">{stock.itemCode}</span>
                                            )}
                                        </div>
                                    </div>
                                    <div>
                                        <div className="ticker-value">{stock.closePrice}</div>
                                        <div className={`ticker-trend-badge ${trendClass}`}>
                                            <TrendIcon size={12} />
                                            <span>
                                                {stock.compareToPreviousClosePrice} ({stock.fluctuationsRatio})
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                ) : (
                    <div className="text-center my-5 text-muted">
                        <p>현재 제공되는 주식 시황 정보가 없습니다.</p>
                    </div>
                )}
            </Container>
        </div>
    );
};

export { StockMarket };